import React from "react";

import MultiplySvg from "../../assets/images/icons/multiply.svg";

export const MultiplyIcon: React.FC<{ alt?: string }> = ({ alt }) => (
    <img
        src={MultiplySvg}
        alt={alt || "Multiply"}
    />
);
